import APIUtils from '@spothero/utils/api';

/**
 * Object containing all Vehicle API methods
 *
 * @property {add} add - Add Vehicle
 * @property {getVehicleInfos} getVehicleInfos - Get vehicle types
 * @property {getOversizedFee} getOversizedFee - Get if car costs oversize fee
 * @property {getColorOptions} getColorOptions - Get color options for all vehicles
 * @module api/vehicle
 */
const VehicleAPI = {
    /**
     *
     * @function add
     * @see {@link https://spothero.com/api/v1/docs/endpoints/#!/Users/get_users_user_id_vehicles|Documentation}
     * @param {object} requestData - Data to send with post
     * @param {string} userId - User's id
     * @returns {Promise<object>} - API response
     */
    add(requestData, userId) {
        return APIUtils.post(`/users/${userId}/vehicles/`, requestData, {
            headers: {'SpotHero-Version': '2019-08-22'},
        });
    },

    /**
     *
     * @function getVehicleInfos
     * @see {@link https://spothero.com/api/v1/docs/endpoints/#!/Vehicles/get_vehicle_types|Documentation}
     * @param {object} search - Search Object
     * @returns {Promise<object>} - API response
     */
    getVehicleInfos(search) {
        return APIUtils.get('vehicle-types/', {
            search,
        });
    },

    /**
     *
     * @function getOversizedFee
     * @param {object} param - Top level param
     * @param {string} param.make - Car Make
     * @param {string} param.model - Car Model
     * @param {string} param.year - Car Year
     * @returns {Promise<object>} - API response
     * @todo api missing from v1 docs
     */
    getOversizedFee({make, model, year}) {
        return APIUtils.get('vehicle-types/oversized-fee/', {
            make,
            model,
            year,
        });
    },

    /**
     *
     * @function getColorOptions
     * @see {@link https://spothero.com/api/v1/docs/endpoints/#!/Vehicles/get_vehicle_colors|Documentation}
     * @returns {Promise<object>} - API response
     */
    getColorOptions() {
        return APIUtils.get('vehicle-colors/');
    },
};

export default VehicleAPI;
